import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

const GoogleAutocomplete = ({
    streetData,
    children,
    onChange,
    manually,
    defaultValue,
    icon,
    label,
    InputClassName = "",
    LabelClassName = "",
    autocompleteContainerClass = "",
    callback,
}) => {

    const [address, setAddress] = useState("");

    const handleChangeAddress = (newAddress, data) => {
        setAddress(newAddress);
        if (onChange) {
            onChange(newAddress);
        }
    };

    const handleSelectAddress = (newAddress, placeId, suggestion) => {
        setAddress(newAddress);
        geocodeByAddress(newAddress)
            .then((results) => {
                if (callback) {
                    callback(results[0]);
                }
                return getLatLng(results[0]);
            })
            .then((latLng) => console.log("Success", latLng))
            .catch((error) => console.error("Error", error));
    };

    useEffect(() => {
        if (defaultValue) {
            setAddress(defaultValue);
        }
    }, [defaultValue]);

    return (
        <PlacesAutocomplete
            value={address}
            onChange={handleChangeAddress}
            onSelect={handleSelectAddress}
        >
            {({ getInputProps }) => (
                <div className='relative'>
                    <div className="relative">
                        <input
                            {...getInputProps({
                                id: "googleaddress",
                                placeholder: "Street address 1",
                                className: `form-control location-search-input border-clr border-[1px] px-3.5 pt-5 pb-1 min-h-[54px] block w-full 
                                    placeholder:text-input1 text-t2 sm:text-lg text-base rounded-[6px] focus-visible:outline-none 
                                    focus-visible:border-blue peer pl-10 ` + InputClassName
                            })}
                        />

                        <div className="absolute inset-y-0 end-0 flex items-center pr-3 pointer-events-none">
                            {icon}
                        </div>
                    </div>

                </div>
            )}
        </PlacesAutocomplete>
    );
};

export default GoogleAutocomplete;
